import { avatarGrid, palette, type Avatar } from "../lib/avatar";

/** A student's 8-bit character, drawn as crisp SVG pixels. */
export function PixelAvatar({ avatar, size }: { avatar: Avatar; size: number }) {
  const colours = palette(avatar);
  const cells = avatarGrid(avatar).flatMap((row, y) =>
    row.split("").map((c, x) => (c === "." ? null : <rect key={`${x}-${y}`} x={x} y={y} width={1.02} height={1.02} fill={colours[c]} />))
  );
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" shapeRendering="crispEdges" role="img" aria-label="ตัวละครของฉัน">
      {cells}
    </svg>
  );
}
